window.AddNonCandidateForm = function (scope, brand, userPermissions, positionsDataService, brandServices, employmentTypesFactory) {

    var _formName = 'add-non-candidate-form-'+brand.id;
    var self = this;
    var _protected = BaseForm.call(self, _formName, scope);

    self.data = {};

    //prospect types
    self.PROSPECT_TYPES = OnBoardingAPI.NON_CANDIDATE_PROSPECT_TYPE;

    self.data.brandId = brand.id;
    self.data.isBrandArchived = brand.is_archived;
    //hold some data
    self.data.positions = [];
    //errors
    self.data.errors = {};
    //user type deafult value
    self.data.type = self.PROSPECT_TYPES.NEW_NON_APPLICANT;
    //no data loading is required yet
    self.load = function () {
        //load positions
        positionsDataService.getActivePositionsFlat(false, self.data.brandId).then(function (positions) {
            self.data.positions = positions;
        });
        userPermissions.getBrandPolicy(self.data.brandId).then((policyParser)=>{
            self.policyParser = policyParser;
        })
    };

    //Hold new harri user
    self.data.newHarriUser = true;
    self.data.newPhone = true;
    self.data.phoneDisable = false;

    self.setGDRPEnabled = function (isGDRPEnabled) {
        self.isGDRPEnabled = isGDRPEnabled;
    };

    self.isActionShow= function (filters) {
        self.isFilterShow = filters && filters['hidden_candidate'];
    };

    const checkUploadDocsPermission = () => {
        return self.policyParser.position(self.data.position.category.code, self.data.position.code).has(userPermissions.PERMISSIONS.UPLOAD_DOCUMENTS);
    };

    self.chekingExistUserByPhone = false;
    self.phoneServerValidation = function () {
        var defer = $q.defer();
        if (window.intlTelInputUtils.isValidNumber(self.data['phone'])) {
            self.chekingExistUserByPhone = true;
            DashboardAPI.checkUserRegistrationByPhone(self.data.phone).then(function (result) {
                if (result.on_harri && result.user_info) {
                    self.data.first_name = result.user_info.first_name;
                    self.data.last_name = result.user_info.last_name;
                    self.data.email = result.user_info.email || '';
                    self.data.user_id = result.user_info.id;
                    self.data.newPhone = false;
                    self.phoneExistMessage = "Phone already exist";
                } else {
                    delete self.data.user_id;
                    self.data.newPhone = true;
                    self.phoneExistMessage = "";
                }
                defer.resolve();
            })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                })
                .finally(function () {
                    self.chekingExistUserByPhone = false;
                    self.syncScope();
                });
            return defer.promise;
        }
    };

    self.chekingExistUserByEmail = false;
    self.emailServerValidation = function () {
        var defer = $q.defer();
        if (self.data.email) {
            self.chekingExistUserByEmail = true;
            DashboardAPI.checkUserRegistration(self.data.email).then(function (result) {
                if (result.on_harri && result.user_info) {
                    self.data.first_name = result.user_info.first_name;
                    self.data.last_name = result.user_info.last_name;
                    self.data.phone = result.user_info.phone || '';
                    self.data.user_id = result.user_info.id;
                    self.data.newHarriUser = false;
                    self.data.phoneDisable = true;
                    self.emailExistMessage = "Email already exist";
                    self.checkEmploymentTypeSettings(result.user_info.id);
                } else {
                    delete self.data.user_id;
                    self.data.type = self.PROSPECT_TYPES.NEW_NON_APPLICANT;
                    self.disablePaperworkField = false;
                    self.data.newHarriUser = true;
                    self.data.phoneDisable = false;
                    self.emailExistMessage = "";
                }
                defer.resolve();
            })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                })
                .finally(function () {
                    self.chekingExistUserByEmail = false;
                    self.syncScope();
                });
            return defer.promise;
        } else {
            self.data.type = self.PROSPECT_TYPES.NEW_NON_APPLICANT;
            self.disablePaperworkField = false;
        }
    };

    self.enableFields = function (field) {
        if (field === 'phone') {
            self.data.newPhone = true;
        } else {
            self.data.phoneDisable = false;
        }
        self.data.newHarriUser = true;

        self.emailExistMessage = "";
        self.phoneExistMessage = "";
    };

    self.checkEmploymentTypeSettings = (userId) => {
        brandServices.check(brandServices.SERVICES.EMPLOYMENT_TYPES, self.data.brandId)
            .then(isEmploymentTypesServiceEnabled => {
                if (isEmploymentTypesServiceEnabled) {
                    return employmentTypesFactory.checkEmploymentTypeSettingsUsersMatch(self.data.brandId, [{id: userId}], 'COMMS_AND_ACCESS', true);
                } else {
                    return Promise.resolve({status: 'continue'});
                }
            })
            .then(result => {
                switch (result.status) {
                    case 'showConfirmationDialog':
                        self.data.type = self.PROSPECT_TYPES.EXISTING_NON_APPLICANT;
                        self.disablePaperworkField = true;
                        break;
                    default:
                        self.data.type = self.PROSPECT_TYPES.NEW_NON_APPLICANT;
                        self.disablePaperworkField = false;
                        break;
                }
            });
    }

    self.validator.validateCustom = function (field, optionsField, rule, showError, callback) {
        var value = self.validator.getFieldValue(field);
        var name = field.attr("name");

        self.validator.validation['type'] = self.validator.validation['type'] || { errors: {} };

        switch (rule.name) {

            case "requiredIfNot":
                var dependencyField = rule.params[0];
                if (!self.data[dependencyField] && !value) {
                    self.validator.validation[name].errors[rule.name] = true;
                    return false;
                }

                break;

            case "permission-check":

                if (self.data.position) {
                    const canUploadDocs = checkUploadDocsPermission();

                    if (self.data.type === self.PROSPECT_TYPES.EXISTING_NON_APPLICANT && !canUploadDocs) {
                        self.validator.validation.type.errors[rule.name] = true;
                        return false;
                    } else {
                        self.validator.validation.type.errors[rule.name] = false;
                    }
                }
                break;
        }
        return true;
    };

    var checkIfBlockedUser = function () {
        var defer = $q.defer();
        if (self.data.user_id) {
            $q.all({
                users: OnBoardingAPI.getProspectsByUserIds(self.data.brandId, [self.data.user_id], ['SERVICE_ENDED', 'HIRED']),
                policyParser: userPermissions.getBrandPolicy(self.data.brandId)

            }).then(function (res) {
                var user = res['users'][0];
                var policyParser = res['policyParser'];
                var canRehireBlockedEmployees = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BLOCKED_PAST_EMPLOYEES);
                if (user.is_blocked) {
                    if (canRehireBlockedEmployees) {
                        hConfirm({
                            title: $filter("translate")("Blocked for rehire"),
                            text: $filter("translate")("This employee has been blocked for rehire. Are you sure you want to rehire this employee?"),
                            confirmButton: $filter("translate")("Yes"),
                            cancelButton: $filter("translate")("Cancel"),
                            callback: function (confirmed) {
                                if (confirmed) {
                                    defer.resolve();
                                } else {
                                    defer.reject();
                                }
                            }
                        });
                    } else {
                        hAlert({
                            title: $filter("translate")("Failed to rehire"),
                            text: $filter("translate")("This employee has been blocked for rehire. For more info, please contact the HR manager."),
                            custom_class: 'rejection-templates-error-alert',
                            button: {
                                text: $filter("translate")("Okay")
                            }
                        });
                        defer.reject();
                    }
                } else {
                    defer.resolve();
                }
            }).catch(function (err) {
                console.error(err);
                defer.reject(err);
            });
        } else {
            defer.resolve();
        }
        return defer.promise;
    };
    //saving the form
    self.save = function () {
        if(!self.data.isBrandArchived) {
        var defer = $q.defer();

        var submitBtn = $('.'+_formName).find('.submit-btn');
        self.validator.validate(function (isValid) {
            if (isValid) {

                //lock button
                submitBtn.button('loading');
                checkIfBlockedUser().then(function () {
                    createNonApplicant().then(function(result){

                        OnBoardingAPI.createProspect(self.data.brandId,
                            result.user_id,
                            self.data.position.id,
                            self.data.type,
                            self.data.newHarriUser,
                            self.data.received_applicant_consent).then(function(prospect){

                               let savedUser = prospect;

                                savedUser.user = {
                                    id: result.user_id,
                                    first_name: self.data.first_name,
                                    last_name: self.data.last_name
                                };

                                if (self.data.email) {
                                    savedUser.user['email'] = self.data['email'];
                                }

                                if (window.intlTelInputUtils.isValidNumber(self.data['phone'])) {
                                    savedUser.user['phone'] = self.data['phone'];
                                }

                                savedUser.position = self.data.position;
                                savedUser.type = self.data.type;
                                savedUser.brand_id = self.data.brandId;

                                //call after save and pass data to it
                                _protected.trigger("on-form-saved",savedUser);

                                submitBtn.button('reset');

                                //reset form
                                resetForm();

                            }, function(res){
                                if(res.status === 400){
                                    //alert error
                                    hAlert($filter("translate")("Error!"), $filter("translate")("This employee already exists in your team. You can view the employee records and data from the documents section."));
                                }else{
                                    hAlert($filter("translate")("Error!"), $filter("translate")("Something went wrong"));
                                }
                                //reject
                                defer.reject({code: "save", message: "Form didn't save"});
                                //reset button
                                submitBtn.button('reset');
                            });

                    },function(result){
                        //alert error
                        hAlert($filter("translate")("Error!"),result.data.data);
                        //reject
                        defer.reject({code: "save", message: "Form didn't save"});
                        //reset button
                        submitBtn.button('reset');
                    });
                },function (result) {
                    hAlert($filter("translate")("Error!"),result.data.data);
                    defer.reject({code: "save", message: "Form didn't save"});
                    submitBtn.button('reset');
                });

            }else {
                defer.reject({code: "validation", message: "Form didn't validate"});
            }
        });


        return defer.promise;
        }
    };


    var createNonApplicant = function(){
        var defer = $q.defer();

        if(!self.data.user_id){
            //create non-candidate user
            var phone = window.intlTelInputUtils.isValidNumber(self.data['phone'])? self.data['phone']: null;
            var email = self.data.email || null;
            OnBoardingAPI.createNonApplicant(
                self.data.brandId,
                self.data.first_name,
                self.data.last_name,
                email,
                self.data.phoneDisable? undefined: window.intlTelInputUtils.formatNumber(phone, undefined, window.intlTelInputUtils.numberFormat.E164),
                self.data.received_applicant_consent
            ).then(function (result) {
                    defer.resolve({
                        user_id : result.id
                    });
                },function(result){
                    defer.reject(result);
                });
        }else{
            defer.resolve({
                user_id : self.data.user_id
            });
        }

        return defer.promise;
    }

    //reset form data
    var resetForm = function(){
        self.data.first_name = '';
        self.data.last_name = '';
        self.data.email = '';
        self.data.phone = '';
        self.data.position = {};
        self.data.type = self.PROSPECT_TYPES.NEW_NON_APPLICANT;
        self.disablePaperworkField = false;
        self.validator.validation = {};
        self.data.newHarriUser = true;
        self.data.newPhone = true;
        self.data.received_applicant_consent = false;
        self.emailExistMessage = "";
        self.phoneExistMessage = "";

        self.enableFields('email');
        self.enableFields('phone');

        scope.$digest();
    }

    //load data or init
    var init = function(){
        //load data
        self.load();
    }

    init();
}
